module.exports = "<countries-page></countries-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/countries.html
// module id = 2129
// module chunks = 0